<tt-page class="col-xs-12 col-md-4 sp-0" *ngIf="!!setting">
    <tt-page-heading *ngIf="!!setting.webpage_heading" [ttModel]="setting.webpage_heading"></tt-page-heading>

    <tt-card>
        <tt-input ttLabel="filtervalue" ttFocus="true" [(ttModel)]="setting.filtervalue" ttShowClearButton></tt-input>
    </tt-card>

    <tt-list [ttData]="itemsListModels" [ttFilter]="setting.filtervalue"></tt-list>

    <tt-card *ngIf="setting.show_setting === '1'">
        <tt-button-settings></tt-button-settings>
    </tt-card>
</tt-page>
